export const RouteGetReportPowerBI = "/report/powerbi";

export interface ReportPowerBIEmbedItem {
  reportId: string;
  reportName: string;
  embedUrl: string;
}

export interface ResponseGetReportPowerBI {
  accessToken: string;
  embedUrl: ReportPowerBIEmbedItem[];
  expiry: string;
}
